import { useOnClickOutside } from '../hooks/useOnClickOutside';
import { Menu } from './Menu';
import { FC, useRef, useState } from 'react';

interface Props {
  disableCancel?: boolean;
  onClickOption?: () => void;
  onClickCancel?: () => void;
  onClickFinish?: () => void;
}

export const MenuButton: FC<Props> = ({
  disableCancel,
  onClickOption,
  onClickFinish,
  onClickCancel,
}) => {
  const ref = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  useOnClickOutside(ref, () => setShowMenu(false));

  const toggleShowMenu = () => setShowMenu((prev) => !prev);

  const _onClickOption = () => {
    onClickOption();
    setShowMenu(false);
  };

  const onFinish = () => {
    onClickFinish();
    setShowMenu(false);
  };

  const onCancel = () => {
    onClickCancel();
    setShowMenu(false);
  };

  return (
    <div>
      <div ref={ref}>
        <button
          className="rounder relative cursor-pointer border-none bg-[#7E8A9A] px-[.4rem] text-[1.875rem] font-bold text-white"
          onClick={toggleShowMenu}
        >
          <span className="h-[1.875rem]">＋</span>
        </button>

        {showMenu && (
          <Menu
            disableCancel={disableCancel}
            onClickOption={!!onClickOption ? _onClickOption : undefined}
            onFinish={!!onClickFinish ? onFinish : undefined}
            onCancel={!!onClickCancel ? onCancel : undefined}
          />
        )}
      </div>
    </div>
  );
};
